import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Image from "@shared/components/contents/image/Image";
import PresentationCard from "./PresentationCard";
const PresentationCardPreview = () => {
    return (_jsx(PresentationCard, { image: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }), imagePosition: "left", title: "Titre", description: "Zone avec la description", colorText: "#343434" }));
};
export default PresentationCardPreview;
